import {Map, List} from 'immutable';

import {
  MESSAGE_LIST_REQUEST,
  MESSAGE_LIST_SUCCESS,
  MESSAGE_LIST_FAILURE,
  MESSAGE_READ_REQUEST,
  MESSAGE_READ_SUCCESS,
  MESSAGE_READ_FAILURE,
  MESSAGE_UPDATE_REQUEST,
  MESSAGE_UPDATE_SUCCESS,
  MESSAGE_UPDATE_FAILURE,
  MESSAGE_CREATE_REQUEST,
  MESSAGE_CREATE_SUCCESS,
  MESSAGE_CREATE_FAILURE,
  MESSAGE_DELETE_REQUEST,
  MESSAGE_DELETE_SUCCESS,
  MESSAGE_DELETE_FAILURE,
  MESSAGE_FORM_DESTROY,
  MESSAGE_CSV_DOWNLOAD_REQUEST,
  MESSAGE_CSV_DOWNLOAD_SUCCESS,
  MESSAGE_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function messages(
  state=Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
    form: null,
  }),
  action
) {
  Logger.log('debug', `[messages.reducers] messages(%j, %j)`, state, action);

  switch(action.type) {

    case MESSAGE_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case MESSAGE_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case MESSAGE_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case MESSAGE_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case MESSAGE_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case MESSAGE_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case MESSAGE_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case MESSAGE_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case MESSAGE_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case MESSAGE_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case MESSAGE_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case MESSAGE_CREATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case MESSAGE_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case MESSAGE_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case MESSAGE_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case MESSAGE_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case MESSAGE_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case MESSAGE_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case MESSAGE_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `messages.reducers loaded.`);
